import { prefix } from './actions';

export const banners = state => state[prefix].banners;
export const listAdmin = state => state[prefix].listAdmin;
export const loading = state => state[prefix].loading;
export const saving = state => state[prefix].saving;
export const savedBanner = state => state[prefix].savedBanner;
